<template>
	<div class="occupation-edit-wrapper">
		<form
			autocomplete="off"
			method="post"
			data-vv-scope="form"
			@keyup.enter="
				() => {
					return false;
				}
			"
			@submit.prevent="
				() => {
					return false;
				}
			"
		>
			<!-- <div class="title-info-wrapper">
				<div class="title-info">
					<div class="edit-detail-header">
						<h4>{{ cemeteryName }} - <span class="edit-occupation">{{ occupationSimpleCode }}</span></h4>
						<div class="right">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g id="location"><path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M5.25 8.99938C5.25 4.77101 9.01774 1.5297 13.45 2.43425C13.4646 2.43722 13.4792 2.43976 13.4939 2.44186C14.6879 2.61242 15.847 3.30712 16.7697 4.22973C19.4866 6.94664 19.1182 10.4201 17.5816 13.7474C16.048 17.0681 13.4439 19.9948 12.1697 21.269C12.1059 21.3329 12.0448 21.3494 12 21.3494C11.9552 21.3494 11.8941 21.3329 11.8303 21.269C10.906 20.3447 9.24496 18.5123 7.82038 16.2719C6.38595 14.0161 5.25 11.4376 5.25 8.99938ZM3.75 8.99938C3.75 3.83467 8.3699 -0.120317 13.7284 0.960175C15.3255 1.19479 16.7579 2.09668 17.8303 3.16907C21.2134 6.55215 20.5818 10.8287 18.9434 14.3763C17.302 17.9306 14.5561 21.0039 13.2303 22.3297C12.5374 23.0226 11.4626 23.0226 10.7697 22.3297C9.794 21.354 8.05502 19.4364 6.55461 17.0768C5.06404 14.7327 3.75 11.8612 3.75 8.99938ZM9.25 8.99933C9.25 7.48054 10.4812 6.24933 12 6.24933C13.5188 6.24933 14.75 7.48054 14.75 8.99933C14.75 10.5181 13.5188 11.7493 12 11.7493C10.4812 11.7493 9.25 10.5181 9.25 8.99933ZM12 4.74933C9.65279 4.74933 7.75 6.65212 7.75 8.99933C7.75 11.3465 9.65279 13.2493 12 13.2493C14.3472 13.2493 16.25 11.3465 16.25 8.99933C16.25 6.65212 14.3472 4.74933 12 4.74933Z" fill="currentColor"/></g></svg>
							<p>{{ $t(`${translateID}.buttons.view_on_map`) }}</p>
						</div>
					</div>
				</div>
			</div> -->
			<div class="row">
				<div class="col-12 col-sm-6 col-lg-5">
					<div class="form-group">
						<MaterialSelect
							:disabled="!!form.id"
							class="city-form-group city-bg"
							id="input-cemetery"
							name="cemetery"
							label="name"
							v-model.trim="cemeteryId"
							:options="cemeteries"
							v-validate="rulesField('cemetery_id', { required: true })"
							:data-vv-scope="vScope"
							:inputClasses="[{ 'is-invalid': fnHasError('cemetery', vScope) }]"
							:error="fnFirstError('cemetery', vScope)"
						>
							{{ $t(`${modelTranslateID}.cemetery`) }}
						</MaterialSelect>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-lg-3">
					<div class="form-group">
						<MaterialSelect
							:disabled="readonlyForm"
							class="city-form-group city-bg"
							id="input-sector"
							name="sector"
							label="number"
							v-model.trim="form.sector_id"
							:initialData="form.sector"
							:options="sectors"
							v-validate="rulesField('sector_id', { required: true })"
							:data-vv-scope="vScope"
							:inputClasses="[{ 'is-invalid': fnHasError('sector', vScope) }]"
							:error="fnFirstError('sector', vScope)"
						>
							{{ $t(`${modelTranslateID}.sector`) }}
						</MaterialSelect>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-lg-2">
					<div class="form-group">
						<MaterialInput
							:readonly="readonlyForm"
							:disabled="readonlyForm"
							class="city-form-group city-bg"
							id="input-row"
							name="row"
							v-model.trim="form.row"
							v-validate="rulesField('row')"
							:data-vv-scope="vScope"
							:inputClasses="[{ 'is-invalid': fnHasError('row', vScope) }]"
							:error="fnFirstError('row', vScope)"
						>
							{{ $t(`${modelTranslateID}.row`) }}
						</MaterialInput>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-lg-2">
					<div class="form-group">
						<MaterialInput
							:readonly="readonlyForm"
							:disabled="readonlyForm"
							class="city-form-group city-bg"
							id="input-number"
							name="number"
							v-model.trim="form.number"
							v-validate="rulesField('number', { required: true })"
							:data-vv-scope="vScope"
							:inputClasses="[{ 'is-invalid': fnHasError('number', vScope) }]"
							:error="fnFirstError('number', vScope)"
						>
							{{ $t(`${modelTranslateID}.number`) }}
						</MaterialInput>
					</div>
				</div>
			</div>

			<div class="row details_adding">
				<div class="col-12 col-sm edit-occupation-details">
					<div class="edit-occupation-form">
						<div class="row">
							<div class="col-12 col-sm-6">
								<div class="form-group">
									<MaterialSelect
										:disabled="readonlyForm"
										class="city-form-group city-bg"
										id="input-occupation_type"
										name="occupation_type"
										label="name"
										v-model.trim="form.occupation_type_id"
										:options="types"
										v-validate="rulesField('occupation_type_id', { required: true })"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError('occupation_type', vScope) }]"
										:error="fnFirstError('occupation_type', vScope)"
									>
										{{ $t(`${modelTranslateID}.occupation_type`) }}
									</MaterialSelect>
								</div>
							</div>
							<div class="col-12 col-sm-6">
								<div class="form-group">
									<MaterialSelect
										:disabled="readonlyForm"
										class="city-form-group city-bg"
										id="input-occupation_state_type"
										name="occupation_state_type"
										label="name"
										v-model.trim="form.occupation_state_type_id"
										:options="states"
										v-validate="rulesField('occupation_state_type_id')"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError('occupation_state_type', vScope) }]"
										:error="fnFirstError('occupation_state_type', vScope)"
									>
										{{ $t(`${modelTranslateID}.occupation_state_type`) }}
									</MaterialSelect>
								</div>
							</div>

							<div class="col-12 col-sm-6">
								<div class="form-group">
									<MaterialInput
										:readonly="readonlyForm"
										:disabled="readonlyForm"
										type="number"
										class="city-form-group city-bg"
										id="input-burials_capacity"
										name="burials_capacity"
										v-model.trim="form.burials_capacity"
										v-validate="rulesField('burials_capacity', { required: true, integer: true, min_value: 0 })"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError('burials_capacity', vScope) }]"
										:error="fnFirstError('burials_capacity', vScope)"
									>
										{{ $t(`${modelTranslateID}.burials_capacity`) }}
									</MaterialInput>
								</div>
							</div>
							<div class="col-12 col-sm-6">
								<div class="form-group">
									<MaterialInput
										:readonly="readonlyForm"
										:disabled="readonlyForm"
										type="number"
										class="city-form-group city-bg"
										id="input-entombment_capacity"
										name="entombment_capacity"
										v-model.trim="form.entombment_capacity"
										v-validate="rulesField('entombment_capacity', { required: true, integer: true, min_value: 0 })"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError('entombment_capacity', vScope) }]"
										:error="fnFirstError('entombment_capacity', vScope)"
									>
										{{ $t(`${modelTranslateID}.entombment_capacity`) }}
									</MaterialInput>
								</div>
							</div>

							<div class="col-12 col-sm-6">
								<div class="form-group">
									<MaterialInput
										:readonly="readonlyForm"
										:disabled="readonlyForm"
										type="number"
										class="city-form-group city-bg"
										id="input-cremation_capacity"
										name="cremation_capacity"
										v-model.trim="form.cremation_capacity"
										v-validate="rulesField('cremation_capacity', { required: true, integer: true, min_value: 0 })"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError('cremation_capacity', vScope) }]"
										:error="fnFirstError('cremation_capacity', vScope)"
									>
										{{ $t(`${modelTranslateID}.cremation_capacity`) }}
									</MaterialInput>
								</div>
							</div>
							<div class="col-12 col-sm-6">
								<div class="form-group">
									<MaterialInput
										:readonly="true"
										:disabled="true"
										type="number"
										class="city-form-group city-bg"
										id="input-total_capacity"
										name="total_capacity"
										:value="form.total_capacity"
										v-validate="rulesField('total_capacity', { required: true, integer: true, min_value: 0 })"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError('total_capacity', vScope) }]"
										:error="fnFirstError('total_capacity', vScope)"
									>
										{{ $t(`${modelTranslateID}.total_capacity`) }}
									</MaterialInput>
								</div>
							</div>

							<div class="col-12 col-sm-12">
								<div class="row">
									<div class="col-12 col-sm-6 city-form-group upload-image">
										<UploadMultipleImage
											:disabled="readonlyForm"
											v-model="form.images"
											:maxImage="maxImages"
											:enableMainImage="enableMainImage"
											:imageSize="imageSize"
											:imagesPerRow="imagesPerRow"
											:direction="imageDirection"
											:noSpaceBetween="true"
											:heightAuto="false"
											pathProperty="url"
											filenameProperty="filename"
											:extraNewProperties="newImageProperties"
											imageClass="background-contain"
										/>
									</div>
									<div class="col-12 col-sm-6">
										<div class="row">
											<div class="col-12">
												<div class="form-group">
													<MaterialSelect
														:disabled="readonlyForm"
														class="city-form-group city-bg"
														id="input-occupation_direction_type"
														name="occupation_direction_type"
														label="name"
														v-model.trim="form.occupation_direction_type_id"
														:options="directions"
														v-validate="rulesField('occupation_direction_type_id')"
														:data-vv-scope="vScope"
														:inputClasses="[{ 'is-invalid': fnHasError('occupation_direction_type', vScope) }]"
														:error="fnFirstError('occupation_direction_type', vScope)"
													>
														{{ $t(`${modelTranslateID}.occupation_direction_type`) }}
													</MaterialSelect>
												</div>
											</div>
											<div class="col-12">
												<div class="form-group">
													<MaterialSelect
														:disabled="readonlyForm"
														class="city-form-group city-bg"
														id="input-occupation_position_type"
														name="occupation_position_type"
														label="name"
														v-model.trim="form.occupation_position_type_id"
														:options="positions"
														v-validate="rulesField('occupation_position_type_id')"
														:data-vv-scope="vScope"
														:inputClasses="[{ 'is-invalid': fnHasError('occupation_position_type', vScope) }]"
														:error="fnFirstError('occupation_position_type', vScope)"
													>
														{{ $t(`${modelTranslateID}.occupation_position_type`) }}
													</MaterialSelect>
												</div>
											</div>
											<div class="col-12">
												<div class="form-group">
													<MaterialInput
														:readonly="readonlyForm"
														:disabled="readonlyForm"
														type="number"
														class="city-form-group city-bg"
														id="input-price"
														name="price"
														v-model.trim="form.price"
														:step="stepPriceDecimalPlaces"
														v-validate="rulesField('price', { required: true, decimal: priceDecimalPlaces, min_value: 0 })"
														:data-vv-scope="vScope"
														:inputClasses="[{ 'is-invalid': fnHasError('price', vScope) }]"
														:error="fnFirstError('price', vScope)"
													>
														{{ $t(`${modelTranslateID}.price`) }}
														<template #grpAppend>
															<span class="input-group-text">{{ currency.symbol }}</span>
														</template>
													</MaterialInput>
												</div>
											</div>
											<div class="col-12 align-self-center form-group">
												<div class="form-check city-form-check form-check-inline">
													<input
														:readonly="readonlyForm"
														:disabled="readonlyForm"
														class="city-form-group city-bg"
														type="checkbox"
														id="input-show_price"
														name="show_price"
														v-model.trim="form.show_price"
														:false-value="false"
														:true-value="true"
													/>
													<label
														class="form-check-label h-auto"
														:for="`input-show_price`"
													>
														<div class="d-flex flex-column align-items-start">
															<span> {{ $t(`${modelTranslateID}.show_price`) }}</span>
														</div>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-12 col-sm-12">
								<div class="form-group">
									<MaterialTextarea
										:readonly="readonlyForm"
										:disabled="readonlyForm"
										class="city-form-group city-bg"
										:id="`input-inscription`"
										:name="`inscription`"
										:rows="1"
										v-model.trim="form.inscription"
										v-validate="rulesField('inscription')"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError(`inscription`, vScope) }]"
										:error="fnFirstError(`inscription`, vScope)"
									>
										{{ $t(`${modelTranslateID}.inscription`) }}
									</MaterialTextarea>
								</div>
							</div>
							<div class="col-12 col-sm-12">
								<div class="form-group">
									<MaterialTextarea
										:readonly="readonlyForm"
										:disabled="readonlyForm"
										class="city-form-group city-bg"
										:id="`input-obs`"
										:name="`obs`"
										:rows="3"
										v-model.trim="form.obs"
										v-validate="rulesField('obs')"
										:data-vv-scope="vScope"
										:inputClasses="[{ 'is-invalid': fnHasError(`obs`, vScope) }]"
										:error="fnFirstError(`obs`, vScope)"
									>
										{{ $t(`${modelTranslateID}.obs`) }}
									</MaterialTextarea>
								</div>
							</div>

							<div class="col-12 col-sm-12">
								<OccupationFiles
									v-model="form.files"
									:panelCfg="panelCfg"
									:vScope="vScope"
									:readonlyForm="readonlyForm"
									:baseTranslateID="baseTranslateID"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-4 adding-interment_deed_owners">
					<div class="deed_owners">
						<h4>{{ $t(`${modelTranslateID}.deed_owner.titles`) }}</h4>
						<PlusItem
							v-if="allowAddDeedOwner"
							@add="onAddDeedOwner"
						/>
						<div
							v-for="(item, idx) in deed_owners"
							:key="`deed_owner-item-${idx}`"
							class="deed_owner-item"
							@click.prevent="onViewDetailDeedOwner(item)"
						>
							<span class="holders-names">
								<span>{{ (item.names ?? []).length ? (item.names ?? []).join(", ") : '[SEM TITULAR]'}}</span>
							</span>
							<p class="application-date">
								<span v-if="item.occupation_right_type"> {{ item.occupation_right_type?.name }} <span>|</span></span>
								<span v-if="item.occupation_term_right_type"> {{ item.occupation_term_right_type?.name }} <span>|</span></span>
								<span> {{ formatDateToDisplay(item.application_at) }} </span>
							</p>
						</div>
					</div>
					<div class="interments">
						<div class="title_adding">
							<h4>{{ $t(`${modelTranslateID}.interment.titles`) }}</h4>
						</div>
						<PlusItem
							v-if="allowAddInterment"
							@add="onAddDeedInterment"
						/>
						<div
							v-for="(item, idx) in interments"
							:key="`occupation-interment-item-${idx}`"
							class="interment-item"
							@click.prevent="onViewDetailInterment(item)"
						>
							<div class="interment-name">
								<span class="">{{ item?.entity?.name }}</span>
							</div>
							<p class="interment-birth_death_age">
								{{ formatDateToDisplay(item?.entity?.birth_at ?? "n/a") }} - {{ formatDateToDisplay(item?.entity?.death_at ?? "n/a") }}
								<span class="">({{ item?.entity?.age ?? "n/a" }} {{ $t(`${modelTranslateID}.interment.years`).toLowerCase() }})</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";
import { customMergeDeep } from '@config/utils';
import { EVENTS } from "../../../shared/config/event-constants";

export default {
	mixins: [FormMixin],
	components: {
		UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ "@/components/form/UploadMultipleImage"),
		PlusItem: () => import(/* webpackChunkName: "cemeteries-plusitem" */ "./../../common/PlusItem"),
		OccupationFiles: () => import(/* webpackChunkName: "cemeteries-deedowner-files" */ "./elements/OccupationFiles")
	},
	props: {
		eventDeedOwnerViewDetail: {
			type: String,
			default: EVENTS.SHOW_MODAL_DETAIL_DEED_OWNER
		},
		eventIntermentViewDetail: {
			type: String,
			default: EVENTS.SHOW_MODAL_DETAIL_INTERMENT
		},
		cemeteries: {
			type: Array,
			default: () => {
				return [];
			}
		},
		types: {
			type: Array,
			default: () => {
				return [];
			}
		},
		states: {
			type: Array,
			default: () => {
				return [];
			}
		},
		directions: {
			type: Array,
			default: () => {
				return [];
			}
		},
		positions: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		let idPanel = "occupation";
		return {
			idPanel: idPanel
		};
	},
	computed: {
		cemetery() {
			return this.form?.cemetery ?? {};
		},
		cemeteryId: {
			// getter
			get() {
				return this.cemetery?.id ?? null;
			},
			// setter
			set(newValue) {
				if(!this.form.cemetery){
					this.$set(this.form, 'cemetery', {id: null});
				}
				this.form.cemetery.id = newValue;
			}
		},
		cemeteryName() {
			return this.cemetery?.name ?? null;
		},
		cemeteryCode() {
			return this.cemetery?.code ?? null;
		},
		sectors() {
			return this.cemeteryId ? this.cemeteries.find(c => c.id == this.cemeteryId)?.sectors : [];
		},
		sector() {
			return this.form?.sector ?? {};
		},
		occupationSimpleCode() {
			return this.form?.code ? this.form?.code.toUpperCase().replace(this.cemeteryCode.toUpperCase(), "").trim() : null;
		},
		interments() {
			return this.form?.occupation_interments ?? [];
		},
		numInterments() {
			return this.interments.length;
		},
		deed_owners() {
			return this.form?.occupation_deed_owners ?? [];
		},
		numDeedOwners() {
			return this.deed_owners.length;
		},
		burials_capacity() {
			return parseInt(this.form?.burials_capacity ?? 0);
		},
		entombment_capacity() {
			return parseInt(this.form?.entombment_capacity ?? 0);
		},
		cremation_capacity() {
			return parseInt(this.form?.cremation_capacity ?? 0);
		},
		total_capacity() {
			return this.burials_capacity + this.entombment_capacity + this.cremation_capacity;
		},
		imagesCfg() {
			return this.panelCfg?.panel?.images ?? {};
		},
		imagesNewCfg() {
			return this.imagesCfg?.new ?? {};
		},
		newImageProperties() {
			return this.imagesNewCfg?.properties ?? {};
		},
		enableMainImage() {
			return this.imagesCfg.main_image ?? false;
		},
		imageSize() {
			return "small";
		},
		maxImages() {
			return this.imagesCfg.max ?? 1;
		},
		imagesPerRow() {
			return this.imagesCfg.per_row ?? 1;
		},
		imageDirection() {
			return this.imagesCfg.direction ?? "vertical";
		},
		allowAddDeedOwner() {
			return !this.readonlyForm && this.numDeedOwners == 0;
		},
		allowAddInterment() {
			return !this.readonlyForm; // && this.numInterments == 0
		},
		allowViewDetailDeedOwner() {
			return this.actions?.deed_owner?.detail;
		},
		allowViewDetailInterment() {
			return this.actions?.interment?.detail;
		},
	},
	methods: {
		onViewDetailDeedOwner(item = {}) {
			if (!this.allowViewDetailDeedOwner) return;

			if (this.eventDeedOwnerViewDetail) {
				this.$eventBus.publish(
					this.moduleCode,
					this.eventDeedOwnerViewDetail,
					{
						data: { ...item },
						fnSave: (params = {}) => this.updateEntities('deed_owners', params),
					}
				);
			}
		},
		onAddDeedOwner(params = {}) {
			if (!this.allowAddDeedOwner) return;

			if (this.eventDeedOwnerViewDetail) {
				this.$eventBus.publish(
					this.moduleCode,
					this.eventDeedOwnerViewDetail,
					{
						data: {occupation_id: this.form?.id},
						fnSave: (params = {}) => this.updateEntities('deed_owners', params),
					}
				);
			}
		},
		onViewDetailInterment(item = {}) {
			if (!this.allowViewDetailInterment) return;

			if (this.eventIntermentViewDetail) {
				this.$eventBus.publish(
					this.moduleCode,
					this.eventIntermentViewDetail,
					{
						data: { ...item },
						fnSave: (params = {}) => this.updateEntities('interments', params),
					}
				);
			}
		},
		onAddDeedInterment(params = {}) {
			if (!this.allowAddInterment) return;

			if (this.eventIntermentViewDetail) {
				this.$eventBus.publish(
					this.moduleCode,
					this.eventIntermentViewDetail,
					{
						data: {occupation_id: this.form?.id},
						fnSave: (params = {}) => this.updateEntities('interments', params),
					}
				);
			}
		},
		updateEntities(type, params = {}) {
			const {action, data, ...rest} = params;
			let key = `occupation_${type}`;
console.log(action, data)
			if(this.form) {
				if(!this.form[key]) {
					this.$set(this.form, key, []);
				}
				let idx = type == 'interments' ?
					this.form[key].findIndex(h => h?.entity?._new && data?.entity?._new && h?.entity?._new == data?.entity?._new
						|| h?.entity?.id && data?.entity?.id && h?.entity?.id == data?.entity?.id) :
					this.form[key].findIndex(h => h?._new && data?._new && h?._new == data?._new
						|| h?.id && data?.id && h?.id == data?.id);
console.log(idx)
				switch (action) {
					case EVENTS.CREATED:
					case EVENTS.CREATED_VIRTUAL:
					case EVENTS.UPDATED:
					case EVENTS.UPDATED_VIRTUAL:
						if(idx == -1) {
							this.form[key].push(JSON.parse(JSON.stringify(data)));
						}else{
							customMergeDeep(this.form[key][idx], data);
						}
						break;
					case EVENTS.DELETED:
					case EVENTS.DELETED_VIRTUAL:
						if(idx != -1) {
							this.form[key].slice(idx, 1);
						}
						break;
					default:
						break;
				}
			}
		}
	},
	watch: {
		total_capacity: {
			immediate: false,
			handler: function (value) {
				this.form.total_capacity = value;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.occupation-edit-wrapper {
	padding: 5px;

	.title-info-wrapper {
		display: flex;
		justify-content: space-between;
		position: relative;

		.edit-detail-header {
			color: rgba(24, 20, 41, 0.6);
			font-family: var(--city-medium-font-family);
			font-size: 20px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px;
			display: flex;
			gap: 16px;
			margin: 0 0 30px 0;

			h4 {
				margin: 0;

				.edit-occupation {
					cursor: pointer;
					text-decoration: underline;
				}
			}

			.right {
				display: flex;
				gap: 8px;
				align-items: center;
				justify-content: center;
				color: var(--primary-color);

				// img {
				//     height: 24px;
				//     width: 24px;
				// }

				p {
					margin: 0;
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 16px;
					cursor: pointer;
				}
			}
		}
	}

	.details_adding {
		display: flex;

		.upload-image {
			min-height: 270px;
		}

		.edit-occupation-details {
			margin-right: 50px;

			.edit-occupation-form {
			}
		}

		.adding-interment_deed_owners {
			> div:not(:last-child) {
				margin-bottom: 40px;
			}

			.interments .interment-item,
			.interments .deed_owner-item,
			.deed_owners .interment-item,
			.deed_owners .deed_owner-item {
				cursor: pointer;
				padding: 10px 16px 0;
				border: 1px solid rgba(24, 20, 41, 0.2);
				box-sizing: border-box;
				border-radius: 4px;
				min-height: 56px;

				.holders-names,
				.interment-name {
					font-weight: 500;
					font-size: 16px;
					line-height: 20px;
					margin-bottom: 3px;
				}

				.interment-birth_death_age,
				.application-date {
					font-weight: 700;
					font-size: 11px;
					line-height: 12px;
					color: rgba(24, 20, 41, 0.4);
				}
			}

			h4 {
				letter-spacing: normal;
				margin: 0 0 16px;
			}

			.deed_owners {
				// margin-bottom: 25px;
			}

			.interments {
				.title_adding {
					display: flex;
					justify-content: space-between;
					cursor: pointer;
				}

				> div:not(.title_adding) {
					margin-bottom: 15px;
				}
			}
		}
	}
}
</style>
